import redmonkLight from "../assets/redmonk-light.svg";
import redmonkDark from "../assets/redmonk-dark.svg";
import { useTheme } from "./ThemeContext";

export function useRedmonkLogo() {
  const { isDark } = useTheme();
  return isDark ? redmonkLight : redmonkDark;
}
